import {apiUrl, alert} from '../helper'
import echarts from 'echarts'
import $ from 'jquery'

export default {
  data () {
    return {
      //
    }
  },
  methods: {
    /**
     * echart 柱图
     * @param  {[type]} n       [description]
     * @param  {[type]} u       [description]
     * @param  {[type]} flagstr [description]
     * @return {[type]}         [description]
     */
    echartBar: function (n, u, flagstr) {
      var sameY = false
      // var name = this.smartComInfo.shortname + k
      if (u.length > 1 && u[0] === u[1]) {
        sameY = true
        // console.log(sameY)
      }
      // console.log(n)
      var segments = []
      var maxList = []
      var minList = []
      var legend = []
      var colors = ['#5793f3', '#d14a61']
      var yAxis = []
      var series = []
      var arr = []
      var datax = []
      var danwei = []
      let num = n[0].length - 1 > 2 ? 2 : n[0].length - 1
      for (let z = 0;z < num;z++) {
        arr.push([])
        // colors.push(this.getRandomColor())
      }
      for (let i in n) {
        if (i == 0) {
          // console.log(n[0])
          for (let k in n[i]) {
            if (k > 0 && k < 3) {
              legend.push(n[i][k])
            }
          }
        }
        if (n.length - 6 >= 0) {
          if (i > n.length - 6) {
            datax.push(n[i][0])
            // console.log(datax)
            for (let x in n[i]) {
              if (x > 0 && x < 3) {
                var newvalue = parseFloat(n[i][x])
                // if (n[i][x] > 100000000) {
                //   newvalue = n[i][x] / 100000000
                // }
                arr[x - 1].push(newvalue)
              }
            }
          }
        } else {
          if (i > 0) {
            datax.push(n[i][0])
            // console.log(datax)
            for (let x in n[i]) {
              if (x > 0 && x < 3) {
                var newvalue = parseFloat(n[i][x])
                // if (n[i][x] > 100000000) {
                //   newvalue = n[i][x] / 100000000
                // }
                arr[x - 1].push(newvalue)
              }
            }
          }
        }
      }
      function UnityUnits (x) {
        for (let i in arr[0]) {
          arr[0][i] = (arr[0][i] / x).toFixed(2)
        }
        for (let j in arr[1]) {
          arr[1][j] = (arr[1][j] / x).toFixed(2)
        }
      }
      // console.log(arr)
      if (sameY) {
        var max1 = Math.max.apply(Math, arr[0])
        var min1 = Math.min.apply(Math, arr[0])
        var max2 = Math.max.apply(Math, arr[1])
        var min2 = Math.min.apply(Math, arr[1])
        var biggest = Math.abs(max1) > Math.abs(min1) ? Math.abs(max1): Math.abs(min1)
        var biggest2 = Math.abs(max2) > Math.abs(min2) ? Math.abs(max2): Math.abs(min2)
        if (biggest > 100000000 && biggest2 > 100000000) {
          UnityUnits(100000000)
          danwei.push('亿' +u[0])
        } else if (biggest > 100000000 && biggest2 > 10000) {
          UnityUnits(100000000)
          danwei.push('亿' +u[0])
        } else if (biggest > 100000000 && biggest2 >= 0) {
          UnityUnits(10000)
          danwei.push('万' +u[0])
        } else if (biggest > 10000 && biggest2 > 100000000) {
          UnityUnits(100000000)
          danwei.push('亿' +u[0])
        } else if (biggest > 10000 && biggest2 > 10000) {
          UnityUnits(10000)
          danwei.push('万' +u[0])
        } else if (biggest > 10000 && biggest2 >= 0) {
          UnityUnits(10000)
          danwei.push('万' +u[0])
        } else if (biggest >= 0 && biggest2 > 100000000) {
          UnityUnits(10000)
          danwei.push('万' +u[0])
        } else if (biggest >= 0 && biggest2 > 10000) {
          UnityUnits(10000)
          danwei.push('万' +u[0])
        } else if (biggest >= 0 && biggest2 >= 0) {
          UnityUnits(1)
          danwei.push(u[0])
        }
      } else {
      // 获取最大最小值 都取整 1， 10 ，100 ，1000
        for (let n in arr) {
          let min = Math.min.apply(Math, arr[n])
          let max = Math.max.apply(Math, arr[n])
          // console.log(max)
          // console.log(min)

          if (min >= 0) {
            if (max > 100000000) {
              let x = parseInt((max/100000000).toFixed(2)[0])
              let m = Math.floor((max/100000000).toFixed(2))
              maxList.push((x + 1) *Math.pow(10, m.toString().length - 1))
              minList.push(0)
              for (let i in arr[n]) {
                arr[n][i] = (arr[n][i] / 100000000).toFixed(2)
              }
              danwei.push('亿' + u[n])
            } else if (max > 10000) {
              let x = parseInt((max/10000).toFixed(2)[0])
              let m = Math.floor((max/10000).toFixed(2))
              maxList.push((x + 1) *Math.pow(10, m.toString().length - 1))
              minList.push(0)
              for (let i in arr[n]) {
                arr[n][i] = (arr[n][i] / 10000).toFixed(2)
              }
              danwei.push('万' + u[n])
            } else {
              let x = parseInt(max.toFixed(2)[0])
              let m = Math.floor(max.toFixed(2))
              maxList.push((x + 1) *Math.pow(10, m.toString().length - 1))
              minList.push(0)
              danwei.push(u[n])
            }
          }
          else if (max <=0) {
            if (Math.abs(min) > 100000000) {
              let x = parseInt((Math.abs(min)/100000000).toFixed(2)[0])
              let m = Math.floor((Math.abs(min)/100000000).toFixed(2))
              minList.push((x + 1) *Math.pow(10, m.toString().length - 1))
              maxList.push(0)
              for (let i in arr[n]) {
                arr[n][i] = (arr[n][i] / 100000000).toFixed(2)
              }
              danwei.push('亿' + u[n])
            } else if (Math.abs(min) > 10000) {
              let x = parseInt((Math.abs(min)/10000).toFixed(2)[0])
              let m = Math.floor((Math.abs(min)/10000).toFixed(2))
              minList.push((x + 1) *Math.pow(10, m.toString().length - 1))
              maxList.push(0)
              for (let i in arr[n]) {
                arr[n][i] = (arr[n][i] / 10000).toFixed(2)
              }
              danwei.push('万' + u[n])
            } else {
              let x = parseInt(Math.abs(min).toFixed(2)[0])
              let m = Math.floor(Math.abs(min).toFixed(2))
              minList.push((x + 1) *Math.pow(10, m.toString().length - 1))
              maxList.push(0)
              danwei.push(u[n])
            }
          } else{
            if (max > 100000000 || Math.abs(min) > 100000000) {
              let x = parseInt((max/100000000).toFixed(2)[0])
              let m = Math.floor((max/100000000).toFixed(2))
              maxList.push((x + 1) *Math.pow(10, m.toString().length - 1))
              let y = parseInt((Math.abs(min)/100000000).toFixed(2)[0])
              let k = Math.floor((Math.abs(min)/100000000).toFixed(2))
              minList.push((y + 1) *Math.pow(10, k.toString().length - 1))
              for (let i in arr[n]) {
                arr[n][i] = (arr[n][i] / 100000000).toFixed(2)
              }
              danwei.push('亿' + u[n])
            } else if (max > 10000 || Math.abs(min) > 10000) {
              let x = parseInt((max/10000).toFixed(2)[0])
              let m = Math.floor((max/10000).toFixed(2))
              maxList.push((x + 1) *Math.pow(10, m.toString().length - 1))
              let y = parseInt((Math.abs(min)/10000).toFixed(2)[0])
              let k = Math.floor((Math.abs(min)/10000).toFixed(2))
              minList.push((y + 1) *Math.pow(10, k.toString().length - 1))
              for (let i in arr[n]) {
                arr[n][i] = (arr[n][i] / 10000).toFixed(2)
              }
              danwei.push('万' + u[n])
            } else {
              let x = parseInt((max.toFixed(2)[0]))
              let m = Math.floor(max.toFixed(2))
              maxList.push((x + 1) *Math.pow(10, m.toString().length - 1))
              let y = parseInt(Math.abs(min).toFixed(2)[0])
              let k = Math.floor(Math.abs(min).toFixed(2))
              minList.push((y + 1) *Math.pow(10, k.toString().length - 1))
              danwei.push(u[n])
            }
          }
        }
        // console.log(maxList)
        console.log(minList)
        if (minList.length > 1) {
          // console.log('123')
          if (minList[0] == 0 && minList[1] == 0) {
            segments.push(maxList[0] / 5)
            segments.push(maxList[1] / 5)
          } else if (maxList[0] == 0 && maxList[1] == 0) {
            segments.push(minList[0] / 5)
            segments.push(minList[1] / 5)
          } else if (minList[0] == 0 && maxList[1] == 0) {
            minList[0] = maxList[0]
            maxList[1] = minList[1]
            segments.push(maxList[0] / 2)
            segments.push(maxList[1] / 2)
          } else if (maxList[0] == 0 &&minList[1] == 0) {
            maxList[0] = minList[0]
            minList[1] = maxList[1]
            segments.push(maxList[0] / 2)
            segments.push(maxList[1] / 2)
          } else if (minList[0] > 0 && minList[1] == 0) {
            // console.log('??')
            // 左边有正，负数 右边没有负数
            // 同一量级
            if (minList[0].toString().length > maxList[0].toString().length) {
              maxList[0] = Math.pow(10, minList[0].toString().length - 1)
            } else if (maxList[0].toString().length > minList[0].toString().length) {
              minList[0] = Math.pow(10, maxList[0].toString().length - 1)
            }
            if (maxList[0] == minList[0]) {
              var segment = 2
              segments.push(maxList[0] / 2)
            } else {
              if (this.maxDivisor(maxList[0], minList[0]).toString()[0] == '1') {
                parseInt(maxList[0].toString()[0]) % 2 ? maxList[0] = maxList[0] + this.maxDivisor(maxList[0], minList[0]): null
                parseInt(minList[0].toString()[0]) % 2 ? minList[0] = minList[0] + this.maxDivisor(maxList[0], minList[0]): null
              }
              var segment = maxList[0] / this.maxDivisor(maxList[0], minList[0])
              segments.push(maxList[0] / segment)
            }
            if (maxList[1] % segment) {
              maxList[1] = (Math.floor(maxList[1] / segment) + 1) * segment
            }
            minList[1] = minList[0] * maxList[1] / maxList[0]
            segments.push(maxList[1] / segment)

          } else if (minList[0] > 0 && maxList[1] == 0) {
            // console.log('??')
            // 左边有正，负数 右边没有正数
            if (minList[0].toString().length > maxList[0].toString().length) {
              maxList[0] = Math.pow(10, minList[0].toString().length - 1)
            } else if (maxList[0].toString().length > minList[0].toString().length) {
              minList[0] = Math.pow(10, maxList[0].toString().length - 1)
            }
            if (maxList[0] == minList[0]) {
              var segment = 2
              segments.push(maxList[0] / 2)
            } else {
              if (this.maxDivisor(maxList[0], minList[0]).toString()[0] == '1') {
                parseInt(maxList[0].toString()[0]) % 2 ? maxList[0] = maxList[0] + this.maxDivisor(maxList[0], minList[0]): null
                parseInt(minList[0].toString()[0]) % 2 ? minList[0] = minList[0] + this.maxDivisor(maxList[0], minList[0]): null
              }
              var segment = minList[0] / this.maxDivisor(maxList[0], minList[0])
              segments.push(minList[0] / segment)
            }
            if (minList[1] % segment) {
              minList[1] = (Math.floor(minList[1] / segment) + 1) * segment
            }
            maxList[1] = maxList[0] * minList[1] / minList[0]
            segments.push(minList[1] / segment)

          } else if (minList[1] > 0 && minList[0] == 0) {
            // console.log('??')
            // 右边有正，负数  左边没有负数
            if (minList[1].toString().length > maxList[1].toString().length) {
              maxList[1] = Math.pow(10, minList[1].toString().length - 1)
            } else if (maxList[1].toString().length > minList[1].toString().length) {
              minList[1] = Math.pow(10, maxList[1].toString().length - 1)
            }
            if (maxList[1] == minList[1]) {
              var segment = 2
            } else {
              if (this.maxDivisor(maxList[1], minList[1]).toString()[0] == '1') {
                parseInt(maxList[1].toString()[0]) % 2 ? maxList[1] = maxList[1] + this.maxDivisor(maxList[1], minList[1]): null
                parseInt(minList[1].toString()[0]) % 2 ? minList[1] = minList[1] + this.maxDivisor(maxList[1], minList[1]): null
              }
              var segment = maxList[1] / this.maxDivisor(maxList[1], minList[1])
              // segments.push(maxList[1] / segment)
            }
            if (maxList[0] % segment) {
              maxList[0] = (Math.floor(maxList[0] / segment) + 1) * segment
            }
            minList[0] = minList[1] * maxList[0] / maxList[1]
            segments.push(maxList[0] / segment)
            segments.push(maxList[1] / segment)

          } else if (minList[1] > 0 && maxList[0] == 0) {
            // console.log('??')
            // 右边有正， 负数  左边没有正数
            if (minList[1].toString().length > maxList[1].toString().length) {
              maxList[1] = Math.pow(10, minList[1].toString().length - 1)
            } else if (maxList[1].toString().length > minList[1].toString().length) {
              minList[1] = Math.pow(10, maxList[1].toString().length - 1)
            }
            if (maxList[1] == minList[1]) {
              var segment = 2
            } else {
              if (this.maxDivisor(maxList[1], minList[1]).toString()[0] == '1') {
                parseInt(maxList[1].toString()[0]) % 2 ? maxList[1] = maxList[1] + this.maxDivisor(maxList[1], minList[1]): null
                parseInt(minList[1].toString()[0]) % 2 ? minList[1] = minList[1] + this.maxDivisor(maxList[1], minList[1]): null
              }
              var segment = minList[1] / this.maxDivisor(maxList[1], minList[1])
              // segments.push(maxList[1] / segment)
            }
            if (minList[0] % segment) {
              minList[0] = (Math.floor(minList[0] / segment) + 1) * segment
            }
            maxList[0] = minList[0] * maxList[1] / minList[1]
            segments.push(minList[0] / segment)
            segments.push(minList[1] / segment)

          } else if (maxList[0] > 0 && maxList[1] > 0 && minList[0] > 0 && minList[1] > 0) {
            // console.log('122222')
            if (maxList[0] > maxList[1] && minList[0] > minList[1]) {
              // console.log('左轴包含右轴')
              // 左轴包含右轴
              if (minList[0].toString().length > maxList[0].toString().length) {
                maxList[0] = Math.pow(10, minList[0].toString().length - 1)
              } else if (maxList[0].toString().length > minList[0].toString().length) {
                minList[0] = Math.pow(10, maxList[0].toString().length - 1)
              }
              if (minList[1].toString().length > maxList[1].toString().length) {
                maxList[1] = Math.pow(10, minList[1].toString().length - 1)
              } else if (maxList[1].toString().length > minList[1].toString().length) {
                minList[1] = Math.pow(10, maxList[1].toString().length - 1)
              }
              if (maxList[0] == minList[0]) {
                maxList[1] > minList[1]? minList[1] = maxList[1] : maxList[1] = minList[1]
                var segment = 2
                segments.push(maxList[0] / 2)
                segments.push(maxList[1] / 2)
              } else {
                if (this.maxDivisor(maxList[0], minList[0]).toString()[0] == '1') {
                  parseInt(maxList[0].toString()[0]) % 2 ? maxList[0] = maxList[0] + this.maxDivisor(maxList[0], minList[0]): null
                  parseInt(minList[0].toString()[0]) % 2 ? minList[0] = minList[0] + this.maxDivisor(maxList[0], minList[0]): null
                }
                  let flag = false
                  // 为true时maxList[0]为变化比较点 false：minList[0]为比较点
                  flag = (maxList[0] / maxList[1]) < (minList[0] / minList[1])?true:false
                  if (flag) {
                    var segment = maxList[0] / this.maxDivisor(maxList[0], minList[0])
                    segments.push(maxList[0] / segment)
                    if (maxList[1] % segment) {
                      maxList[1] = (Math.floor(maxList[1] / segment) + 1) * segment
                    }
                    minList[1] = minList[0] * maxList[1] / maxList[0]
                    segments.push(maxList[1] / segment)
                  } else {
                    var segment = minList[0] / this.maxDivisor(maxList[0], minList[0])
                    segments.push(minList[0] / segment)
                    if (minList[1] % segment) {
                      minList[1] = (Math.floor(minList[1] / segment) + 1) * segment
                    }
                    maxList[1] = maxList[0] * minList[1] / minList[0]
                    segments.push(minList[1] / segment)
                  }

              }
            } else if (maxList[0] < maxList[1] && minList[0] < minList[1]) {
              // console.log('右轴包含左轴')
              // console.log(maxList)
              // console.log(minList)
              // 右轴包含左轴
              if (minList[0].toString().length > maxList[0].toString().length) {
                maxList[0] = Math.pow(10, minList[0].toString().length - 1)
              } else if (maxList[0].toString().length > minList[0].toString().length) {
                minList[0] = Math.pow(10, maxList[0].toString().length - 1)
              }
              if (minList[1].toString().length > maxList[1].toString().length) {
                maxList[1] = Math.pow(10, minList[1].toString().length - 1)
              } else if (maxList[1].toString().length > minList[1].toString().length) {
                minList[1] = Math.pow(10, maxList[1].toString().length - 1)
              }
              // console.log(maxList)
              // console.log(minList)
              if (maxList[1] == minList[1]) {
                maxList[0] > minList[0]? minList[0] = maxList[0] : maxList[0] = minList[0]
                var segment = 2
                segments.push(maxList[0] / 2)
                segments.push(maxList[1] / 2)
              } else {
                if (this.maxDivisor(maxList[1], minList[1]).toString()[0] == '1') {
                  parseInt(maxList[1].toString()[0]) % 2 ? maxList[1] = maxList[1] + this.maxDivisor(maxList[1], minList[1]): null
                  parseInt(minList[1].toString()[0]) % 2 ? minList[1] = minList[1] + this.maxDivisor(maxList[1], minList[1]): null
                }
                  let flag = false
                  // 为true时maxList[1]为变化比较点 false：minList[1]为比较点
                  flag = (maxList[1] / maxList[0]) < (minList[1] / minList[0])? true: false
                  if (flag) {
                    // console.log('???')
                    var segment = maxList[1] / this.maxDivisor(maxList[1], minList[1])
                    if (maxList[0] % segment) {
                      maxList[0] = (Math.floor(maxList[0] / segment) + 1) * segment
                    }
                    minList[0] = minList[1] * maxList[0] / maxList[1]
                    segments.push(maxList[0] / segment)
                    segments.push(maxList[1] / segment)
                  } else {
                    var segment = minList[1] / this.maxDivisor(maxList[1], minList[1])
                    // segments.push(minList[0] / segment)
                    // console.log(segment)
                    if (minList[0] % segment) {
                      minList[0] = (Math.floor(minList[0] / segment) + 1) * segment
                    }
                    // console.log(minList[0])
                    maxList[0] = maxList[1] * minList[0] / minList[1]
                    segments.push(minList[0] / segment)
                    segments.push(minList[1] / segment)
                  }

              }
            } else {
              // console.log('222')
              minList[0] > minList[1] ? minList[1] = minList[0]: minList[0] = minList[1]
              maxList[0] > maxList[1] ? maxList[1] = maxList[0]: maxList[0] = maxList[1]
            }
          } else {
            // console.log('why')
          }
        }
      }
      // console.log(maxList)
      // console.log(legend)
      for (let idx in legend) {
        let tmp = {}
        tmp.name = legend[idx]
        tmp.type = 'bar'
        if (!sameY) {
          tmp.yAxisIndex = idx
        }
        // tmp.yAxisIndex = idx
        tmp.barWidth = '20%'
        tmp.data = arr[idx]
        series.push(tmp)
      }
      if (sameY) {
        let tmp2 = {}
        tmp2.type= 'value'
        tmp2.position ='left'

        tmp2.axisLabel = {
                formatter: '{value} ' + danwei[0]
            }
        yAxis.push(tmp2)
      } else {
        for (let idx in legend) {
          let tmp2 = {}
          tmp2.type= 'value'
          if (maxList.length > 1) {
            tmp2.max = maxList[idx]
            tmp2.min = minList[idx] ? -minList[idx] : 0
            tmp2.interval = segments[idx]
          }
          tmp2.name = legend[idx]
          tmp2.position = idx == 0? 'left': 'right'
          if (idx > 0) {
            tmp2.offset = 20 * (idx - 1)
          }
          tmp2.axisLine = {
            lineStyle: {
              color: colors[idx]
            }
          }
          tmp2.axisLabel = {
                  formatter: '{value} ' + danwei[idx]
              }
          yAxis.push(tmp2)
        }
      }

      //近五年营业收入
      if (flagstr == 'business') {
        var business = setInterval(function () {
          if (document.querySelector('.businesschart')) {
            let echart = document.querySelector('.businesschart')
            var mychart = echarts.init(echart)
            series[1].type = 'line'
            series[1].connectNulls = true
            for (let i in series[1].data) {
              if (series[1].data[i] == 0) {
                series[1].data[i] = null
              }
            }
            var option = {
                color: colors,
                tooltip : {
                  trigger: 'axis',
                  axisPointer : {            // 坐标轴指示器，坐标轴触发有效
                      type : 'line'        // 默认为直线，可选为：'line' | 'shadow'
                  }
                },
                legend: {
                  data: legend
                },
                grid: {
                  left: '1%',
                  right: '4%',
                  bottom: '3%',
                  containLabel: true
                },
                xAxis: [
                  {
                    data: datax,
                    axisTick: {
                      alignWithLabel: true
                    }
                  }
                ],
                graphic: [
                  {
                    type: 'image',
                    left: 0,  // left right只能有一个生效
                    top: 10,
                    z: -10,
                    bounding: 'raw',
                    origin: [75, 75],
                    style: {
                      image: window.location.origin + '/static/images/analyze_shuiyin2.png',
                      width: 350,
                      height: 150,
                      opacity: 0.4
                    }
                  }
                ],
                yAxis: yAxis,
                series: series
            }
            window.clearInterval(business)
            mychart.setOption(option, true)
          }
        }, 100)
      }
      // 近五年归母净利润
      if (flagstr == 'gmjlr') {
        var gmjlr = setInterval(function () {
          if (document.querySelector('.gmjlrchart')) {
            let echart = document.querySelector('.gmjlrchart')

            var mychart = echarts.init(echart)
            series[1].type = 'line'
            series[1].connectNulls = true
            for (let i in series[1].data) {
              if (series[1].data[i] == 0) {
                series[1].data[i] = null
              }
            }
            var option = {
                color: colors,
                tooltip : {
                    trigger: 'axis',
                    axisPointer : {            // 坐标轴指示器，坐标轴触发有效
                        type : 'line'        // 默认为直线，可选为：'line' | 'shadow'
                    }
                },
                legend: {
                  data: legend
                },
                grid: {
                  left: '1%',
                  right: '4%',
                  bottom: '3%',
                  containLabel: true
                },
                xAxis: [
                  {
                    data: datax,
                    axisTick: {
                      alignWithLabel: true
                    }
                  }
                ],
                graphic: [
                  {
                    type: 'image',
                    left: 0,  // left right智能有一个生效
                    top: 10,
                    z: -10,
                    bounding: 'raw',
                    origin: [75, 75],
                    style: {
                      image: window.location.origin + '/static/images/analyze_shuiyin2.png',
                      width: 350,
                      height: 150,
                      opacity: 0.4
                    }
                  }
                ],
                yAxis: yAxis,
                series: series
            }
            window.clearInterval(gmjlr)
            mychart.setOption(option, true)
          }
        }, 100)
      }

      var show = setInterval(function () {
        if (document.querySelector('.industry-chard')) {
          let echart = document.querySelector('.industry-chard')
          var mychart = echarts.init(echart)
          var option = {
            color: colors,
            tooltip : {
              trigger: 'axis',
              axisPointer : {            // 坐标轴指示器，坐标轴触发有效
                type : 'line'        // 默认为直线，可选为：'line' | 'shadow'
              }
            },
            legend: {
              data: legend
            },
            grid: {
              left: '1%',
              right: '1%',
              top: '2%',
              bottom: '3%',
              containLabel: true
            },
            xAxis : [
              {
                data : datax,
                axisTick: {
                  alignWithLabel: true
                }
              }
            ],
            yAxis : yAxis,
            graphic: [
              {
                type: 'image',
                left: 0,  // left right智能有一个生效
                top: 10,
                z: -10,
                bounding: 'raw',
                origin: [75, 75],
                style: {
                  image: window.location.origin + '/static/images/analyze_shuiyin2.png',
                  // image: '/static/images/analyze_shuiyin.png',
                  width: 350,
                  height: 150,
                  opacity: 0.4
                }
              }
            ],
            series : series
          };

          window.clearInterval(show)
          mychart.setOption(option, true)
        }
      },100)
    },
    /**
     * echart折线图
     * @return {[type]} [description]
     */
    echartLine(data, title, legend, plat, divClass, canvasClass) {
      this.curRateChart = plat;
      title = '';
      legend = legend;
      let img_shuiyin = window.location.origin + '/static/images/analyze_shuiyin2.png';

      if ($(canvasClass)) {
        console.log('has canvasClass')
        $(canvasClass).remove();
      }

      let _class = canvasClass.split('#')[1];
      $(divClass).prepend('<div id="'+ _class +'" style="height:180px;width:100%;border:1px solid rgb(232, 238, 245);margin-bottom:10px;"></div>');

      let data_x = [];
      let data_y = [];
      if (plat == 'company') {
        data_x = data.dataX;
        data_y = data.dataY;
      }
      if (plat == 'szse' || plat == 'shse') {
        data_x = data.dataX;
        data_y.push(data.dataY);
        data_y.push(data.dataY2);
      }

      let echart = document.querySelector(canvasClass)
      if (!echart) {
        console.log('!!')
        return false;
      }
      let mychart = echarts.init(echart);

      let option = {
        title: {
          text: title,
          textStyle: {
            color:'#1E88E5',
            fontStyle:'normal',
            fontWeight:'normal',
    　　　　fontSize: 16
          },
        },
         tooltip: {
          trigger: 'axis',
          formatter: function(datas) {
            console.log(datas);
            var res = "<ul><li>" + datas[0].axisValue + '<li/>';
            for (var i=datas.length-1; i>=0; i--) {
              let seriesName = $.trim(datas[i].seriesName);
              if (seriesName && seriesName != '-' && seriesName != '') {
                if (plat !== 'company') {
                  res += "<li style='list-style-type:none;'><span style='display:inline-block;width:9px;height:9px;margin-right:6px;border-radius: 50%;background-color:" + datas[i].color + "'></span>" + datas[i].seriesName + "：" + datas[i].value + ' %'+ "<li/>";
                }
              }
              if (plat == 'company') {
                res += "<li style='list-style-type:none;'><span style='display:inline-block;width:9px;height:9px;margin-right:6px;border-radius: 50%;background-color:" + datas[i].color + "'></span>" + datas[i].value + ' %'+ "<li/>";
              }
            }
            res += '</ul>';
            return res;
          }
        },
        legend: {
          data: legend,
          padding: 2
        },
        grid: {
          left: '1%',
          right: '2%',
          top: '10%',
          bottom: '3%',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          boundaryGap: true,
          data: data_x
        },
        yAxis: {
          type: 'value',
          min: 0,
          max: 100,
          axisLabel: {
            formatter: '{value} %'
          }
        },
        graphic: [
          {
            type: 'image',
            left: 0,  // left right智能有一个生效
            top: 10,
            z: -10,
            bounding: 'raw',
            origin: [75, 75],
            style: {
              image: img_shuiyin,
              width: 350,
              height: 150,
              opacity: 0.4
            }
          }
        ],
        series: data_y
      };
      mychart.setOption(option);
    },
    // 最大公约数
    maxDivisor: function (a, b) {
      for(var i=a;i>0;i--){
        if(a%i==0){
          if(b%i==0){
            return i;
          }
        }
      }
    },
    echartLineNumber(data, title, legend, plat, divClass, canvasClass) {
      this.curRateChart = plat;
      title = title;
      legend = legend;
      let img_shuiyin = window.location.origin + '/static/images/analyze_shuiyin2.png';

      if ($(canvasClass)) {
        $(canvasClass).remove();
      }

      let _class = canvasClass.split('.')[1];
      $(divClass).prepend('<div class="'+ _class +'" style="height:180px;width:100%;border:1px solid rgb(232, 238, 245);margin-bottom:10px;"></div>');

      let data_x = [];
      let data_y = [];
      if (plat == 'company' || plat == 'cumPledge') {
        data_x = data.dataX;
        data_y = data.dataY;
      }

      let echart = document.querySelector(canvasClass)
      if (!echart) {
        console.log('!!')
        return false
      }
      let mychart = echarts.init(echart);

      function formatNum(num) {
        if (!num) {
          return num
        } else {
          num = parseFloat(num);
          return num.toFixed(2);
        }
      }

      let option = {
        title: {
          text: title,
          textStyle: {
            //文字颜色
            color:'#1E88E5',
            //字体风格,'normal','italic','oblique'
            fontStyle:'normal',
            //字体粗细 'normal','bold','bolder','lighter',100 | 200 | 300 | 400...
            fontWeight:'normal',
            //字体系列
            // fontFamily:'sans-serif',
            //字体大小
    　　　　fontSize: 16
          }
        },
        tooltip: {
          trigger: 'axis',
          formatter: function(datas) {
            if (datas[0].value) {
              var res = "<ul>";
              res += "<li>" + datas[0].axisValue + '<li/>';
              res += "<li style='list-style-type:none;'><span style='display:inline-block;width:9px;height:9px;margin-right:6px;border-radius: 50%;background-color: #536DFE'></span>" + formatNum(datas[0].value) + "（%）<li/>";
              res += '</ul>';
              return res;
            }
          }
        },
        legend: {
          data: legend
        },
        grid: {
          left: '4%',
          right: '2%',
          top: '25%',
          bottom: '3%',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          data: data_x,
          axisTick: {
            alignWithLabel: true
          }
        },
        yAxis: {
          type: 'value',
          name: '累计质押比例',  //y轴坐标单位
          // min: 0,
          // max: 100,
          axisLabel: {
            formatter: '{value} %'
          },
          axisPointer: {
            snap: true
          }
        },
        graphic: [
          {
            type: 'image',
            left: 0,  // left right智能有一个生效
            top: 0,
            z: -10,
            bounding: 'raw',
            origin: [75, 75],
            style: {
              image: img_shuiyin,
              width: 350,
              height: 150,
              opacity: 0.4
            }
          }
        ],
        series: [
            {
              name:'质押股数',
              type:'line',
              connectNulls: true, //为空的节点跨过
              // smooth: true,    //平滑连线
              data: data_y.data,
            }
          ]
      };
      mychart.setOption(option);
    },
    /**
     * 返回两个日期之间的日期数组
     * @param  { string } begin 起始日期
     * @param  { string } end   结束日期
     * @return { array  }       完整日期数组
     */
    getAllDay(begin, end) {
      console.log(begin)
      console.log(end)

      Date.prototype.format = function() {
        var s = '';
        var mouth = (this.getMonth() + 1)>=10?(this.getMonth() + 1):('0'+(this.getMonth() + 1));
        var day = this.getDate()>=10?this.getDate():('0'+this.getDate());

        s += this.getFullYear() + '-'; // 获取年份。
        s += mouth + "-"; // 获取月份。
        s += day; // 获取日。

        return (s); // 返回日期。
      };

      var allDay = [];
      var ab = begin.split("-");
      var ae = end.split("-");
      var db = new Date();
      db.setUTCFullYear(ab[0], ab[1] - 1, ab[2]);

      var de = new Date();
      de.setUTCFullYear(ae[0], ae[1] - 1, ae[2]);

      var unixDb = db.getTime();
      var unixDe = de.getTime();
      for (var k = unixDb; k <= unixDe;) {
          allDay.push( (new Date(parseInt(k))).format() );
          k = k + 24 * 60 * 60 * 1000;
      }

      return allDay;
    },
    // echart k线图
    echartKLine: function(data, divClass, canvasClass) {
      if ($(canvasClass)) {
        $(canvasClass).remove();
      }
      let _class = canvasClass.split('.')[1];
      $(divClass).prepend('<div class="'+ _class +'" style="height:400px;width:100%;margin-bottom:10px;"></div>');

      // canvs不存在，退出
      let echart = document.querySelector(canvasClass)
      if (!echart) return false;

      function formatMoney(z) {
        if (!z) {
          return z
        } else {
          let num = z.toString()
          let normdata = ''
          if (num.indexOf('.') !== -1) {
            normdata = num.replace(/(\d)(?=(\d{3})+\.)/g, function($0, $1) {
              return $1 + ","
            })

          } else {
            normdata = num.replace(/(\d)(?=(\d{3})+\b)/g, function($0, $1) {
              return $1 + ","
            })
          }
          if (normdata.indexOf('.') >= 0) {
            let arr = normdata.split('.')
            if (arr[1].length < 2) {
              return normdata + '0'
            } else {
              return normdata.substr(0, normdata.indexOf('.') + 3)
            }
            // return arr[0] + '.' + arr[1]
          } else {
            return normdata
          }
        }
      }

      // 初始化画布
      let mychart = echarts.init(echart);
      var rawData = data.reverse();

      // 计算MAS
      function calculateMA(dayCount, data) {
        var result = [];
        for (var i = 0, len = data.length; i < len; i++) {
          if (i < dayCount) {
            result.push('-');
            continue;
          }
          var sum = 0;
          for (var j = 0; j < dayCount; j++) {
            sum += data[i - j][1];
          }
          // result.push(sum / dayCount);
          result.push(+(sum / dayCount).toFixed(3));
        }
        return result;
      }

      // 日期
      var dates = rawData.map(function (item) {
        return item[0];
      });
      var volumes = rawData.map(function(item) {
        return item[5];
      })

      // 数据
      var data = rawData.map(function (item) {
        return [+item[1], +item[2], +item[3], +item[4]];
      });

      var upColor = '#00da3c';
      var downColor = '#ec0000';

      var option = {
        // backgroundColor: '#21202D',
        backgroundColor: '#ffffff',
        animation: false,
        legend: {
          data: ['日K', 'MA5', 'MA10', 'MA20', 'MA30'],
          inactiveColor: '#777',
          // textStyle: {
          //   color: '#fff'
          // }
        },
        visualMap: {
          show: false,
          seriesIndex: 5,
          dimension: 2,
          pieces: [{
            value: 1,
            color: downColor
          }, {
            value: -1,
            color: upColor
          }]
        },
        // 提示框组件
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            animation: false,
            type: 'cross',
            lineStyle: {
              color: '#376df4',
              width: 2,
              opacity: 1
            }
          },
          formatter: function (param) {
            console.log(param);
            let _d = {
              main: '',
              MA5: '',
              MA10: '',
              MA20: '',
              MA30: '',
              Volume: ''
            };
            for (let h of param) {
              if (h.seriesName == "日K") {
                _d.main = h;
              } else {
                _d[h.seriesName] = h;
              }
            }
            console.log(_d);

            let str = '';
            if (_d.main != '') {
              str = '<ul><li>' + _d.main.name + '</li><hr size=1 style="margin: 3px 0">';
            } else if (_d.MA5 != '') {
              str += '<ul><li>' + _d.MA5.name + '</li><hr size=1 style="margin: 3px 0">';
            } else if (_d.MA10 != '') {
              str += '<ul><li>' + _d.MA10.name + '</li><hr size=1 style="margin: 3px 0">';
            } else if (_d.MA20 != '') {
              str += '<ul><li>' + _d.MA20.name + '</li><hr size=1 style="margin: 3px 0">';
            } else if (_d.MA30 != '') {
              str += '<ul><li>' + _d.MA30.name + '</li><hr size=1 style="margin: 3px 0">';
            } else if (_d.Volume != '') {
              str += '<ul><li>' + _d.Volume.name + '</li><hr size=1 style="margin: 3px 0">';
            }

            if (_d.main != '') {
              str = str
                    + '<li><span style="display:inline-block;width:9px;height:9px;margin-right:6px;border-radius: 50%;background-color:' + _d.main.color + '"></span>日K:</li>'
                    + '<li>- 开盘价: ' + _d.main.data[1] + '</li>'
                    + '<li>- 收盘价: ' + _d.main.data[2] + '</li>'
                    + '<li>- 最低价: ' + _d.main.data[3] + '</li>'
                    + '<li>- 最高价: ' + _d.main.data[4] + '</li>';
            }
            if (_d.MA5 != '') {
              str += '<li><span style="display:inline-block;width:9px;height:9px;margin-right:6px;border-radius: 50%;background-color:' + _d.MA5.color + '"></span>' + 'MA5: ' + _d.MA5.value + '</li>';
            }
            if (_d.MA10 != '') {
              str += '<li><span style="display:inline-block;width:9px;height:9px;margin-right:6px;border-radius: 50%;background-color:' + _d.MA10.color + '"></span>' + 'MA10: ' + _d.MA10.value + '</li>';
            }
            if (_d.MA20 != '') {
              str += '<li><span style="display:inline-block;width:9px;height:9px;margin-right:6px;border-radius: 50%;background-color:' + _d.MA20.color + '"></span>' + 'MA20: ' + _d.MA20.value + '</li>';
            }
            if (_d.MA30 != '') {
              str += '<li><span style="display:inline-block;width:9px;height:9px;margin-right:6px;border-radius: 50%;background-color:' + _d.MA30.color + '"></span>' + 'MA30: ' + _d.MA30.value + '</li>'
            }
            if (_d.Volume != '') {
              str += '<li><span style="display:inline-block;width:9px;height:9px;margin-right:6px;border-radius: 50%;background-color:' + _d.Volume.color + '"></span>' + '成交量: ' + formatMoney(_d.Volume.value) + ' (手)</li>'
            }
            str += '</ul>';
            return str;

            // return [
            //   '<ul>',
            //   '<li>' + main.name + '</li><hr size=1 style="margin: 3px 0">',
            //   '<li><span style="display:inline-block;width:9px;height:9px;margin-right:6px;border-radius: 50%;background-color:' + main.color + '"></span>日K:</li>',
            //   '<li>- 开盘价: ' + main.data[1] + '</li>',
            //   '<li>- 收盘价: ' + main.data[2] + '</li>',
            //   '<li>- 最低价: ' + main.data[3] + '</li>',
            //   '<li>- 最高价: ' + main.data[4] + '</li>',
            //   '<li><span style="display:inline-block;width:9px;height:9px;margin-right:6px;border-radius: 50%;background-color:' + MA5.color + '"></span>' + 'MA5: ' + MA5.value + '</li>',
            //   '<li><span style="display:inline-block;width:9px;height:9px;margin-right:6px;border-radius: 50%;background-color:' + MA10.color + '"></span>' + 'MA10: ' + MA10.value + '</li>',
            //   '<li><span style="display:inline-block;width:9px;height:9px;margin-right:6px;border-radius: 50%;background-color:' + MA20.color + '"></span>' + 'MA20: ' + MA20.value + '</li>',
            //   '<li><span style="display:inline-block;width:9px;height:9px;margin-right:6px;border-radius: 50%;background-color:' + MA30.color + '"></span>' + 'MA30: ' + MA30.value + '</li>',
            //   '<li><span style="display:inline-block;width:9px;height:9px;margin-right:6px;border-radius: 50%;background-color:' + volumes.color + '"></span>' + '成交量: ' + formatMoney(volumes.value) + ' (手)</li>',
            //   '</ul>'
            // ].join('');
          }
        },
        // 坐标轴指示器
        axisPointer: {
          link: { xAxisIndex: 'all' },  //关联不同的坐标系中的 axisPointer
          label: {   //文本标签
            backgroundColor: '#777'
          }
        },
        grid: [
          {
            left: '10%',
            right: '8%',
            height: '50%'
          },
          {
            left: '10%',
            right: '8%',
            top: '66%',
            height: '16%'
          }
        ],
        xAxis: [
          {
            type: 'category',
            data: dates,
            scale: true,
            //坐标轴两边留白策略
            boundaryGap : false,
            // 坐标轴轴线相关设置。
            axisLine: {
              lineStyle: {
                color: '#8392A5' //坐标轴线线的颜色
              }
            },
            //坐标轴在 grid 区域中的分隔线
            splitLine: {
              show: false  //是否显示分隔线。默认数值轴显示，类目轴不显示。
            },
            // splitNumber: 20,  //坐标轴的分割段数
            min: 'dataMin',   //坐标轴刻度最小值
            max: 'dataMax',   //坐标轴刻度最大值
            axisPointer: {
              z: 100
            }
          },
          {
            type: 'category',
            //x 轴所在的 grid 的索引，默认位于第一个 grid。
            gridIndex: 1,
            data: dates,
            scale: true,
            boundaryGap : false,
            axisLine: {
              lineStyle: {
                color: '#8392A5'
              }
            },
            axisTick: {show: false},
            splitLine: {show: false},
            axisLabel: {show: false},
            // splitNumber: 20,
            min: 'dataMin',
            max: 'dataMax'
          }
        ],
        yAxis: [
          {
            scale: true,
            axisLine: {
              lineStyle: { color: '#8392A5' }
            },
            splitLine: { show: false },
          },
          {
            scale: true,
            gridIndex: 1,
            // 坐标轴刻度标签
            axisLabel: {show: false},
            // 坐标轴轴线
            axisLine: {show: false},
            // 坐标轴刻度
            axisTick: {show: false},
            // 坐标轴在 grid 区域中的分隔线
            splitLine: {show: false}
          }
        ],
        // dataZoom 组件 用于区域缩放
        dataZoom: [
          //内置于坐标系中
          //使用户可以在坐标系上通过鼠标拖拽、鼠标滚轮、手指滑动（触屏上）来缩放或漫游坐标系。
          {
            type: 'inside',
            xAxisIndex: [0, 1],  //inside组件 控制控制第一个和第二个X轴
            start: 0,
            end: 100
          },
          //有单独的滑动条
          //用户在滑动条上进行缩放或漫游。
          {
            type: 'slider',
            show: true,  //是否显示 组件
            xAxisIndex: [0, 1],  //slider组件 控制控制第一个和第二个X轴
            top: '90%', //dataZoom-slider组件离容器上侧的距离。
            textStyle: {
              color: '#8392A5',
            },
            dataBackground: {
              areaStyle: {
                color: '#8392A5'
              },
              lineStyle: {
                opacity: 0.8,
                color: '#8392A5'
              }
            },
            start: 0,  //数据窗口范围的起始百分比
            end: 100    //数据窗口范围的结束百分比
          }
        ],
        series: [
          {
            name: '日K',
            type: 'candlestick',
            data: data,
            itemStyle: {
              normal: {
                color: upColor,
                color0: downColor,
                borderColor: null,
                borderColor0: null
              }
            },
            // tooltip: {
            //   formatter: function (param) {
            //     param = param[0];
            //     console.log(param.data[0]);
            //     return [
            //       'Date: ' + param.name + '<hr size=1 style="margin: 3px 0">',
            //       '开盘价: ' + param.data[0] + '<br/>',
            //       '收盘价: ' + param.data[1] + '<br/>',
            //       '最低价: ' + param.data[2] + '<br/>',
            //       '最高价: ' + param.data[3] + '<br/>'
            //     ].join('');
            //   }
            // }
          },
          {
            name: 'MA5',
            type: 'line',
            data: calculateMA(5, data),
            smooth: true,
            showSymbol: false,
            lineStyle: {
              normal: {
                width: 1
              }
            }
          },
          {
            name: 'MA10',
            type: 'line',
            data: calculateMA(10, data),
            smooth: true,
            showSymbol: false,
            lineStyle: {
              normal: {
                width: 1
              }
            }
          },
          {
            name: 'MA20',
            type: 'line',
            data: calculateMA(20, data),
            smooth: true,
            showSymbol: false,
            lineStyle: {
              normal: {
                width: 1
              }
            }
          },
          {
            name: 'MA30',
            type: 'line',
            data: calculateMA(30, data),
            smooth: true,
            showSymbol: false,
            lineStyle: {
              normal: {
                  width: 1
              }
            }
          },
          {
            name: 'Volume',
            type: 'bar',
            xAxisIndex: 1,
            yAxisIndex: 1,
            data: volumes
          }
        ]
      };

      mychart.setOption(option);
    },
  },
  filters: {
    //
  }
}


/** WEBPACK FOOTER **
 ** ./src/common/echartMix.js
 **/